document.addEventListener('DOMContentLoaded', function() {
  // Log to confirm that the script has loaded
  console.log('Dark Mode Toggle Script Loaded');

  // Function to toggle dark mode
  function toggleDarkMode() {
    console.log('Dark Mode Toggle Clicked');
    
    // Toggle the dark-mode class on the body element
    document.body.classList.toggle('dark-mode');
    
    // Check if dark mode is applied or not
    if (document.body.classList.contains('dark-mode')) {
      console.log('Dark Mode Activated');
      localStorage.setItem('dark-mode', 'enabled');
    } else {
      console.log('Dark Mode Deactivated');
      localStorage.setItem('dark-mode', 'disabled');
    }
  }

  // Check if dark mode is enabled in localStorage and apply it on page load
  if (localStorage.getItem('dark-mode') === 'enabled') {
    document.body.classList.add('dark-mode');
    console.log('Dark Mode Initialized from LocalStorage');
  }

  // Add event listener to each dark mode toggle button
  const toggleButtons = document.querySelectorAll('.dark-mode-toggle');
  if (toggleButtons.length === 0) {
    console.log('No dark mode toggle buttons found');
  } else {
    console.log(`Found ${toggleButtons.length} dark mode toggle button(s)`);

    toggleButtons.forEach(button => {
      // Log which button is being clicked
      button.addEventListener('click', function() {
        console.log('Button clicked:', button);
        toggleDarkMode();
      });
    });
  }
});
